import React from "react";
import styles from '../styles/emptyCard.module.scss'
import Icon from "@/wmCompoments/Icon";
import { useTranslation } from "react-i18next";

interface Props {
    name: string
    onClick?: () => void
}
const EmptyCard = (props: Props) => {
    const { name, onClick } = props
    const { t } = useTranslation('accountManagement')
    return <div className={styles.item} onClick={onClick}>

        <div className={styles.content}>
            <Icon name={'icon-account-add'} />
            <div className={styles.name}>{t('add')}{name}</div>
        </div>

    </div>
}

export default EmptyCard